import { ConfirmModalProps } from "./types/confirmModalProps";
import Portal from "../shared/portal/portal";
import ButtonField from "../buttonField/buttonField";
import { ButtonFieldProps } from "../buttonField/types/buttonFieldProps";
import { classNameBtn } from "../shared/button/types/buttonProps";
import './modal.scss';
import { useEffect, useRef } from "react";

const ConfirmModal = (props: ConfirmModalProps) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setTimeout(() => {
            containerRef.current?.focus();
        }, 0);
    }, []);
    
    const confirm = () => {
        props.onConfirm();
        refocus();
    }

    const cancel = () => {
        props.onCancel();
        refocus();
    }

    const refocus = () => {
        if (props.refocus) props.refocus();
    }

    const onDecline = () => {
        if(props.onDecline) props.onDecline();
    }

    const getBtnProps = (title: string, btnClass: string, onClick: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                className: `${classNameBtn.Btn} ${btnClass} btn body-txt-medium`
            },
            placeHolder: title
        };
    }

    const keyboardNavClose = (event: any) => { 
        // Escape
        return event.keyCode === 27 && cancel(); 
    }

    return (
        <Portal>
            <div tabIndex={-1} onKeyDown={keyboardNavClose} ref={containerRef}>
                <div className="modalBackground"></div>
                <div className="modalContent">
                    <div className="confirmModal" style={{ width: props.width, height: props.height }}>
                        <div className="confirmModalBody body-txt-XL">
                            {props.question}
                        </div>
                        <div className="modalBtns">
                            <ButtonField key={1} {...getBtnProps(props.cancelTitle, classNameBtn.SmallSecondary, cancel)}></ButtonField>
                            {props.onDecline && <ButtonField key={3} {...getBtnProps(props.declineTitle!, classNameBtn.Small, onDecline)}></ButtonField>}
                            <ButtonField key={2} {...getBtnProps(props.confirmTitle, classNameBtn.Small, confirm)}></ButtonField>
                        </div>
                    </div>
                </div>
            </div>
        </Portal>
    )
}

export default ConfirmModal;